interface VersionNotificationProps {
  onRefresh: () => void
  onDismiss: () => void
}

export function VersionNotification({
  onRefresh,
  onDismiss,
}: VersionNotificationProps) {
  return (
    <div className="toast toast-top toast-center z-50">
      <div className="alert alert-info shadow-lg">
        <div className="flex items-start gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="h-6 w-6 flex-shrink-0 stroke-current"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <div>
            <h3 className="font-bold">New Version Available</h3>
            <div className="text-xs">
              A new version of the application has been deployed. Please refresh
              to get the latest updates.
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <button className="btn btn-sm btn-primary" onClick={onRefresh}>
            Refresh Now
          </button>
          <button className="btn btn-sm btn-ghost" onClick={onDismiss}>
            Later
          </button>
        </div>
      </div>
    </div>
  )
}
